import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export const useResolveComponent = (
  options?: UseMutationOptions<any, Error, number>
) => {
  return useMutation({
    ...options,
    mutationKey: ["resolveComponent"],
    mutationFn: async (componentId: number) => {
      return axiosInstance
        .post(`/reports/components/${componentId}/resolve`)
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Produkt usunięty z listy.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "resolve-component",
      });
      queryClient.invalidateQueries({ queryKey: ["reportComponents"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.data?.message || "Błąd podczas usuwania produktu.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "resolve-component",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useResolveComponent;
